<template>
  <div class="deangelo cypress-hook--offers-modal">
    <inquire-phone-number
      v-if="modalCurrentUiState === 'inquiry'"
      @update-phone="$emit('update-phone', $event)"></inquire-phone-number>
    <Modal
      v-if="modalCurrentUiState === 'review'"
      :closable="false"
      :shouldLimitHeight="false"
      :shouldNotHavePadding="true"
      modalSize="dual-pane">
      <div class="grid offer">
        <div class="header">{{agreementDisplayLabel}}</div>
        <div class="mobile-inner-grid">
          <div class="image"></div>
          <div class="detail">
            <h1 class="subheader">{{agreement.displayLabel}}</h1>
            <p class="leader" v-html="agreement.displayText"></p>
            <div class="inputs">
              <v-checkbox
                class="input"
                color="#0e74fe"
                hide-details
                v-for="offer in agreement.offers"
                :key="offer.sortOrder"
                v-model="verticalIds[offer.verticalIds]">
                <template slot="prepend">
                  <v-icon color="#ff760a" class="ornament">arrow_upward</v-icon>
                </template>
                <template slot="label">
                  <span class="label" v-html="offer.displayText"></span>
                </template>
              </v-checkbox>
            </div>
          </div>
        </div>
        <div class="controls">
          <v-btn
            @click="$emit('submit-agreement')"
            :disabled="selectedVerticalIds.length === 0"
            color="#ff760a"
            class="control--yes white--text font-weight-bold"
            plain>{{buttonTextContinue}}</v-btn>
          <v-btn
@click="$emit('cancel-offers')"
class="control--no"
flat
color="#333">
            <u>{{buttonTextCancel}}</u>
          </v-btn>
        </div>
        <div class="disclaimers">
          <p class="legal" v-html="agreement.displayFinePrint"></p>
          <offers-policies font-color="white" :embolden="true"></offers-policies>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/Shared/Modal.vue';
import InquirePhoneNumber from '@/components/OffersModalTemplates/shared/InquirePhoneNumber.vue';
import OffersPolicies from '@/components/OffersModalTemplates/shared/OffersPolicies.vue';

export default {
  components: { Modal, InquirePhoneNumber, OffersPolicies },
  props: [
    'agreement',
    'modalCurrentUiState',
    'verticalIds',
    'selectedVerticalIds',
    'buttonTextCancel',
    'buttonTextContinue',
  ],
  computed: {
    agreementDisplayLabel() {
      return this.agreement.displayLabel ? this.agreement.displayLabel : 'Agreements and Offers';
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/mixins';

.deangelo {
  .grid {
    max-height: 650px;
    height: 650px;
    display: grid;
    grid-template-areas:
      'image header'
      'image detail'
      'image controls'
      'image disclaimers';
    grid-template-rows: 40px 1fr auto;
    grid-template-columns: 50% 50%;
    overflow: hidden;
    padding: 0;
    @include small-viewport {
      grid-template-columns: 100%;
      grid-template-rows: 40px 1fr auto auto;

      grid-template-areas:
        'header'
        'mobile-inner-grid'
        'controls'
        'disclaimers';
    }
  }

  .image {
    grid-area: image;
    height: 100%;
    background-image: url(https://images.homegauge.com/extracare/home-moving.jpg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    @include small-viewport {
      display: none;
    }
  }

  .mobile-inner-grid {
    display: contents;
    height: 100%;
    grid-area: mobile-inner-grid;
    overflow-y: hidden;
    @include small-viewport {
      display: grid;
      grid-template-areas:
        'detail';
      grid-template-rows: 100%;
      grid-template-columns: 100%;
    }
  }

  .header {
    align-items: flex-end;
    color: #808080;
    display: flex;
    font-family: 'Barlow Semi Condensed', sans-serif;
    font-size: 13.5px;
    font-weight: 400;
    grid-area: header;
    height: 100%;
    justify-content: center;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    margin-top: 16px;
  }

  .detail {
    grid-area: detail;
    height: 100%;
    overflow-y: auto;
    .input {
      color: black;
    }
  }

  .controls {
    grid-area: controls;
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
    [class^='control'] {
      font-size: 16px;
    }
  }

  .disclaimers {
    grid-area: disclaimers;
    p {
      @include reset-user-agent-margins;
    }
  }

  .header,
  .leader,
  .detail,
  .controls {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
